<template>
  <div>
      <!-- SELECT ALL -->
      <div class="col-xs-12">
        <div class="col-xs-10 col-md-11 underline break-row " ><strong class="uppercase mobileFont">{{this.btnSelect}}</strong></div>
        <div class="col-xs-2 col-md-1 break-row"><input type="checkbox" class="checkboxTool" v-model="this.select" v-on:click="selectAll()" :data-ba-i="!this.select ? 'unselect-all' : 'select-all'"/></div>
      </div>

    <!-- Lista de ferramentas -->

    <!-- Nível 1 -->
    <div v-for="(n, index) in this.nodes" class="col-xs-12">
        <div class="col-xs-10 col-md-11 underline toolName" ><strong class="mobileFont"><i v-bind:class="n.tool.icon " aria-hidden="true"></i> <span v-html="n.tool.title"></span></strong></div>
        <div class="col-xs-2  col-md-1"><input type="checkbox" class="checkboxTool" v-model="n.selected" :data-ba-i="n.selected ? `select-${n.tool.name}` : `unselect-${n.tool.name}`" v-on:click="clickTier1(n)"/></div>

      <!-- Nível 2 -->
      <div v-for="(c, index2) in n.children" >
        <div class="col-xs-10 col-md-11 underline mobileFont"><strong class="mobileFont tier-2"><span v-html="c.tool.title"></span></strong></div>
        <div class="col-xs-2  col-md-1 "><input type="checkbox" class="checkboxTool" v-model="c.selected"  :data-ba-i="!c.selected ? `select-${c.tool.name}` : `unselect-${c.tool.name}`" v-on:click="clickTier2(c, n)"/></div>

      <!-- Nível 3 -->
      <div v-for="(cc, index3) in c.children">
          <div class="col-xs-10 col-md-11 underline mobileFont"><span class="tier-3"></span><span v-html="cc.tool.title"></span></div>
          <div class="col-xs-2  col-md-1"><input type="checkbox" class="checkboxTool" v-model="cc.selected" :data-ba-i="!cc.selected ? `unselect-${cc.tool.name}` : `select-${cc.tool.name}`" v-on:click="clickTier3(cc, c, n)"/></div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import Tools from './tools.vue';
export default {
  name: "tools",
  props: ["nodes", "translations"],
  components: { Tools },
  data() {
    return {
      btnSelect: "",
      select: true
    };
  },
  mounted() 
  {
    this.btnSelect = this.translations.index.label_select_all;
  },
  updated: function() {
    let count = 0;
    for (let i = 0; i < this.nodes.length; i++) {
      if (this.nodes[i].selected) count++;
      this.clear(this.nodes[i]);
    }

    if (count > 0) {
      // this.btnSelect = this.translations.index.label_unselect_all;
      this.select = true;
    } else {
      // this.btnSelect = this.translations.index.label_select_all;
      this.select = false;
    }
  },
  methods: {
    selectAll: function() {
      if (!this.select) {
        for (let i = 0; i < this.nodes.length; i++) {
          this.nodes[i].selected = false;
          this.clickTier1(this.nodes[i]);
          this.nodes[i].selected = true;

        }
      } else {
        for (let i = 0; i < this.nodes.length; i++) {
          this.nodes[i].selected = true;
          this.clickTier1(this.nodes[i]);
          this.nodes[i].selected = false;

        }
      }
    },

    //organiza pra manter selecionados apenas os nodos que possuem subitems selecionados
    clear: function (node) {
      if(node.children.length == 0) return;

      let cont = 0;
      //Alterando o status dos filhos
      for(let i = 0; i<node.children.length; i++){
        if(node.children[i].selected){
          cont++;
          this.clear(node.children[i]);
        }
      }

      if(cont == 0)
        node.selected = false;
      else
        node.selected = true;
    },

    clickTier1: function (node) {
      let status = true;
      if(node.selected){
        status = false;
      }

      //Alterando o status dos filhos
      for(let i = 0; i<node.children.length; i++){
        node.children[i].selected = status;

        //Alterando o status dos "netos"
         for(let j = 0; j< node.children[i].children.length; j++){
            node.children[i].children[j].selected = status;
         }
      }

    },
    clickTier2: function (node, father) {
      let status = true;
      if(node.selected){
        status = false;
      }

      if(status){ //Alterando o status do pai
        father.selected = true;
      }

      //Alterando o status dos filhos
      for(let i = 0; i<node.children.length; i++){
        node.children[i].selected = status;
      }

    },
    clickTier3: function (node, father, grandfather) {
      if(!node.selected){
        father.selected = true; //Alterando o status do pai
        grandfather.selected = true; //Alterando o status do pai do pai
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="scss">
.checkboxTool {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-bottom: 2px;
}

.underline{
    border-bottom: 0.1em solid #dddddd;
    vertical-align: -webkit-baseline-middle;

}

.uppercase{
  text-transform: uppercase;
}

.break-row{
  margin-bottom: 20px;
}

.toolName{
  color: var(--theme-color-primary);
}

// css arrow
span {
  content: "\21B3";
}

.tier-2{
  margin-left: 5%;
}

.tier-3{
  margin-left: 10%;
}

  @media only screen 
    and (min-device-width : 320px) 
    and (max-device-width : 480px){ 
      .mobileFont 
      {
        font-size: 13px;
      }
  }

.tier-2:before, .tier-3:before {
  content: '\21b3';
  padding-right: 10px;
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/virtual-assistant/tools.vue